export default __webpack_public_path__ + "static/media/archive.6829158c.svg";